import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from 'styled-components';
import { spacing, palette } from '@landr/maestro-legacy';

var _templateObject;
var NavDivider = styled.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-width: 0px 0px 0px 1px;\n    border-image: initial;\n    border-color: inherit;\n    border-style: solid;\n    height: 28px;\n    margin: ", ";\n    color: ", ";\n"])), spacing('md'), palette('neutral.700'));
NavDivider.displayName = 'NavDivider';

export { NavDivider };
